var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13636 0C5.77977 0 5.41432 0.122667 5.15591 0.375333C4.89886 0.626667 4.77273 0.984 4.77273 1.33333V2H0V3.33333H0.745909L2.04545 15.396L2.10955 16H12.8905L12.9545 15.396L14.2541 3.33333H15V2H10.2273V1.33333C10.2273 0.984667 10.1025 0.627333 9.84341 0.374667C9.58636 0.122667 9.22023 0 8.86364 0H6.13636ZM6.13636 1.33333H8.86364V2H6.13636V1.33333ZM2.13068 3.33333H12.8693L11.655 14.6667H3.345L2.13068 3.33333ZM7.5 5.33333L4.77273 8H6.81818V12.6667H8.18182V8H10.2273L7.5 5.33333Z",
    fill: "#20639B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreIcon);
export default __webpack_public_path__ + "static/media/restoreIcon.51d0ea57c47101afc0571c35ba9e687c.svg";
export { ForwardRef as ReactComponent };